import type React from 'react';
import { useState, useCallback, useEffect } from 'react';
import { SessionContext } from './SessionContext';
import { getSessionStatus, logout as apiLogout } from '../services/auth';

export const SessionProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [accountAddress, setAccountAddress] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const checkSession = useCallback(async () => {
    try {
      const status = await getSessionStatus();
      setIsAuthenticated(status.authenticated);
      setAccountAddress(status.account_address ?? null);
    } catch {
      setIsAuthenticated(false);
      setAccountAddress(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void checkSession();
  }, [checkSession]);

  const login = useCallback((address: string) => {
    setIsAuthenticated(true);
    setAccountAddress(address);
  }, []);

  const logout = useCallback(async () => {
    try {
      await apiLogout();
    } finally {
      setIsAuthenticated(false);
      setAccountAddress(null);
    }
  }, []);

  return (
    <SessionContext.Provider value={{ isAuthenticated, accountAddress, loading, login, logout, checkSession }}>
      {children}
    </SessionContext.Provider>
  );
};
